import { createContext, useContext } from 'react';
import { User } from '../../entities/user/types';
import { Company } from '../../entities/company/types';

export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: User | null;
  company: Company | null;
}

export interface AuthContextType {
  authState: AuthState;
  login: (email: string, password: string) => Promise<User>;
  logout: () => Promise<void>;
  hasRole: (role: string | string[]) => boolean;
  can: (permission: string) => boolean;
  switchCompany: (company: Company) => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
